import React from "react";
import { useDispatch } from "react-redux";
import { addFilter, addSort } from "../../features/Filtered/FilteredSlice";

const FilterControl = () => {

  const dispatch = useDispatch();
  
  const handleSort = (value) => {
    if (value === 'newest') {
      dispatch(addSort('createdAt'));
    }
    if (value === 'most_liked') {
      dispatch(addSort('likes'));
    }
    if (value === '') {
      dispatch(addSort(''));
    }
  }

  const handleFilter = (value) =>{
    if (value === 'saved') {
      dispatch(addFilter(true));
    }
    if (value === 'all') {
      dispatch(addFilter(false));
    }
  }

  return (
    <div className="sidebar-items">
      <div className="sidebar-content">
        <h4>Sort</h4>
        <select
        onChange={(e) => handleSort(e.target.value)}
          name="sort"
          id="lws-sort"
          className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
        >
          <option value="">Default</option>
          <option value="newest">Newest</option>
          <option value="most_liked">Most Liked</option>
        </select>
      </div>
      <div className="sidebar-content">
        <h4>Filter</h4>
        <div className="radio-group">
          {/* <!-- handle filter on button click --> */}
          <div>
            <input defaultChecked onClick={() => handleFilter('all')}
              type="radio"
              name="filter"
              id="lws-all"
              className="radio"
            />
            <label  htmlFor="lws-all">All</label>
          </div>
          <div>
            <input onClick={() => handleFilter('saved')} type="radio" name="filter" id="lws-saved" className="radio" />
            <label htmlFor="lws-saved">Saved</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControl;
